import { ForgotPassword } from '../components';

export function ForgotPasswordPage() {
   return (
      <div className="flex justify-center items-center">
         <ForgotPassword />
      </div>
   );
}
